import mtsBankPng from './assets/mts-bank.png';


export const ICON_PATH_BY_BIK = {
    '044525232': mtsBankPng,
};
